import * as React from 'react'
  /* @jsx mdx */
import { mdx } from '@mdx-js/react';
/* @jsxRuntime classic */

/* @jsx mdx */

import DefaultLayout from "/home/runner/work/octicons/octicons/docs/node_modules/@primer/gatsby-theme-doctocat/src/components/layout.js";
export const _frontmatter = {};
const layoutProps = {
  _frontmatter
};
const MDXLayout = DefaultLayout;
export default function MDXContent({
  components,
  ...props
}) {
  return <MDXLayout {...layoutProps} {...props} components={components} mdxType="MDXLayout">


    <p><a parentName="p" {...{
        "href": "https://www.npmjs.org/package/@primer/styled-octicons"
      }}><img parentName="a" {...{
          "src": "https://img.shields.io/npm/v/@primer/styled-octicons.svg",
          "alt": "npm version"
        }}></img></a></p>
    <p>{`The `}<inlineCode parentName="p">{`@primer/styled-octicons`}</inlineCode>{` package wraps icon components from `}<a parentName="p" {...{
        "href": "/packages/react"
      }}><inlineCode parentName="a">{`@primer/octicons-react`}</inlineCode></a>{` with `}<a parentName="p" {...{
        "href": "https://primer.style/components/system-props"
      }}>{`system props`}</a>{`, making them easier to style in projects that use `}<a parentName="p" {...{
        "href": "https://styled-system.com/"
      }}>{`styled system`}</a>{`—like `}<a parentName="p" {...{
        "href": "https://primer.style/components"
      }}>{`Primer React`}</a>{`.`}</p>
    <h2>{`Install`}</h2>
    <pre><code parentName="pre" {...{
        "className": "language-shell"
      }}>{`npm install @primer/styled-octicons
`}</code></pre>
    <h2>{`Usage`}</h2>
    <p><inlineCode parentName="p">{`@primer/styled-octicons`}</inlineCode>{`  exports each icons as a named export. This allows you to import only the icons you need:`}</p>
    <pre><code parentName="pre" {...{
        "className": "language-jsx"
      }}>{`import {AlertIcon} from '@primer/styled-octicons'

export () => (
  <AlertIcon color="red.6" mr={2} />
)
`}</code></pre>
    <h2>{`System props`}</h2>
    <p>{`All icon components in `}<inlineCode parentName="p">{`@primer/styled-octicons`}</inlineCode>{` get `}<inlineCode parentName="p">{`color`}</inlineCode>{` and `}<inlineCode parentName="p">{`space`}</inlineCode>{` system props as well as the `}<inlineCode parentName="p">{`sx`}</inlineCode>{` prop. Read the Primer React `}<a parentName="p" {...{
        "href": "https://primer.style/components/system-props"
      }}>{`System Props`}</a>{` documentation for a full list of available props.`}</p>
    <h2>{`Props`}</h2>
    <p>{`In addition to system props, icon components in `}<inlineCode parentName="p">{`@primer/styled-octicons`}</inlineCode>{` accept the same props as components in `}<inlineCode parentName="p">{`@primer/octicons-react`}</inlineCode>{`:`}</p>
    <table>
      <thead parentName="table">
        <tr parentName="thead">
          <th parentName="tr" {...{
            "align": "left"
          }}>{`Name`}</th>
          <th parentName="tr" {...{
            "align": "left"
          }}>{`Type`}</th>
          <th parentName="tr" {...{
            "align": "center"
          }}>{`Default`}</th>
          <th parentName="tr" {...{
            "align": "left"
          }}>{`Description`}</th>
        </tr>
      </thead>
      <tbody parentName="table">
        <tr parentName="tbody">
          <td parentName="tr" {...{
            "align": "left"
          }}>{`aria-label`}</td>
          <td parentName="tr" {...{
            "align": "left"
          }}>{`String`}</td>
          <td parentName="tr" {...{
            "align": "center"
          }}></td>
          <td parentName="tr" {...{
            "align": "left"
          }}>{`Sets the `}<a parentName="td" {...{
              "href": "https://developer.mozilla.org/en-US/docs/Web/Accessibility/ARIA/ARIA_Techniques/Using_the_aria-label_attribute"
            }}><inlineCode parentName="a">{`aria-label`}</inlineCode></a>{` attribute of the `}<inlineCode parentName="td">{`<svg>`}</inlineCode>{`. If no `}<inlineCode parentName="td">{`aria-label`}</inlineCode>{` is defined, `}<inlineCode parentName="td">{`aria-hidden`}</inlineCode>{` will be set to `}<inlineCode parentName="td">{`true`}</inlineCode>{`.`}</td>
        </tr>
        <tr parentName="tbody">
          <td parentName="tr" {...{
            "align": "left"
          }}>{`className`}</td>
          <td parentName="tr" {...{
            "align": "left"
          }}>{`String`}</td>
          <td parentName="tr" {...{
            "align": "center"
          }}></td>
          <td parentName="tr" {...{
            "align": "left"
          }}>{`Sets the `}<inlineCode parentName="td">{`class`}</inlineCode>{` attribute on the `}<inlineCode parentName="td">{`<svg>`}</inlineCode>{`.`}</td>
        </tr>
        <tr parentName="tbody">
          <td parentName="tr" {...{
            "align": "left"
          }}>{`size`}</td>
          <td parentName="tr" {...{
            "align": "left"
          }}>{`Number `}{`|`}{` `}<inlineCode parentName="td">{`"small"`}</inlineCode>{` `}{`|`}{` `}<inlineCode parentName="td">{`"medium"`}</inlineCode>{` `}{`|`}{` `}<inlineCode parentName="td">{`"large"`}</inlineCode></td>
          <td parentName="tr" {...{
            "align": "center"
          }}><inlineCode parentName="td">{`16`}</inlineCode></td>
          <td parentName="tr" {...{
            "align": "left"
          }}>{`The height of the icon. Width will be scaled proportionally.`}</td>
        </tr>
        <tr parentName="tbody">
          <td parentName="tr" {...{
            "align": "left"
          }}>{`verticalAlign`}</td>
          <td parentName="tr" {...{
            "align": "left"
          }}><inlineCode parentName="td">{`"middle"`}</inlineCode>{` `}{`|`}{` `}<inlineCode parentName="td">{`"text-bottom"`}</inlineCode>{` `}{`|`}{` `}<inlineCode parentName="td">{`"text-top"`}</inlineCode>{` `}{`|`}{` `}<inlineCode parentName="td">{`"top"`}</inlineCode>{` `}{`|`}{` `}<inlineCode parentName="td">{`"unset"`}</inlineCode></td>
          <td parentName="tr" {...{
            "align": "center"
          }}><inlineCode parentName="td">{`"text-bottom"`}</inlineCode></td>
          <td parentName="tr" {...{
            "align": "left"
          }}>{`The vertical alignment of the `}<inlineCode parentName="td">{`<svg>`}</inlineCode>{`.`}</td>
        </tr>
      </tbody>
    </table>

    </MDXLayout>;
}
;
MDXContent.isMDXComponent = true;
      